__turbopack_context__.v({
  "breadcrumb": "to3d-module__l3_3YG__breadcrumb",
  "check": "to3d-module__l3_3YG__check",
  "controls": "to3d-module__l3_3YG__controls",
  "createButton": "to3d-module__l3_3YG__createButton",
  "fallbackButton": "to3d-module__l3_3YG__fallbackButton",
  "handIcon": "to3d-module__l3_3YG__handIcon",
  "localDraft": "to3d-module__l3_3YG__localDraft",
  "localDraftActions": "to3d-module__l3_3YG__localDraftActions",
  "notice": "to3d-module__l3_3YG__notice",
  "page": "to3d-module__l3_3YG__page",
  "panel": "to3d-module__l3_3YG__panel",
  "preview": "to3d-module__l3_3YG__preview",
  "selected": "to3d-module__l3_3YG__selected",
  "uploadBox": "to3d-module__l3_3YG__uploadBox",
  "uploadPane": "to3d-module__l3_3YG__uploadPane",
});
